import { GET_LIST, DETAIL } from "../../api/sick-leave";

const state = {
  list: [],
  detail: {},
  columns: [
    {
      label: "NIK",
      field: "nik",
    },
    {
      label: "Employee Name",
      field: "employee_name",
    },
    {
      label: "Position",
      field: "employee_position",
    },
    {
      label: "Department",
      field: "employee_department",
    },
    {
      label: "Company",
      field: "employee_company",
    },
    {
      label: "Total Leave",
      field: "total_absent",
    },
    {
      label: "Action",
      field: "action",
    },
  ],
};
const mutations = {
  SET_LIST: (state, payload) => {
    state.list = payload;
  },
  SET_DETAIL: (state, payload) => {
    state.detail = payload;
  },
};
const actions = {
  GET_LIST: async ({ commit }, args) => {
    const resp = await GET_LIST();
    const data = resp.data.data;
    commit("SET_LIST", data);
  },
  DETAIL: async ({ commit }, id) => {
    console.log(`store, id`, id);
    const resp = await DETAIL(id);
    const data = resp.data.data;
    commit("SET_DETAIL", data);
  },
};
const getters = {
  list: (state) => state.list,
  detail: (state) => state.detail,
  columns: (state) => state.columns,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
